import { useMemo } from "react";
import { useHip3Markets } from "./useHip3Markets";
import { normalizeAndScoreMarkets } from "@/lib/market-utils";

export function useNormalizedMarkets() {
  const query = useHip3Markets();

  const markets = useMemo(() => normalizeAndScoreMarkets(query.data), [query.data]);

  return {
    ...query,
    markets,
  };
}
